import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Component from 'flarum/common/Component';

// Lazy-loaded wrapper for DraftsDropdown
class LazyDraftsDropdown extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "component", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    import(/* webpackChunkName: 'forum/components/DraftsDropdown', webpackMode: 'lazy-once' */ './components/DraftsDropdown').then(module => {
      this.component = module.default;
      this.loading = false;
      m.redraw();
    });
  }
  view(vnode) {
    if (this.loading || !this.component) {
      return m(LoadingIndicator, {
        size: "small"
      });
    }
    const DraftsDropdown = this.component;
    return m(DraftsDropdown, vnode.attrs);
  }
}
export default function () {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!app.session.user || !app.forum.attribute('canSaveDrafts')) return;
    items.add('Drafts', m(LazyDraftsDropdown, {
      state: app.drafts
    }), 20);
  });
}flarum.reg.addChunkModule('399', '345', 'fof-drafts', 'forum/components/DraftsDropdown');
flarum.reg.addChunkModule('399', '345', 'fof-drafts', 'forum/components/DraftsList');
flarum.reg.addChunkModule('399', '345', 'fof-drafts', 'forum/components/DraftsListItem');